/* RK Mehr laden — hängt die nächste Seite an das Raster an.
   Ohne JavaScript bleibt der noscript-Link als Weg zur nächsten Seite. */
(function () {
  'use strict';

  function start(wurzel) {
    var knopf = wurzel.querySelector('[data-rk-knopf]');
    if (!knopf) return;

    var raster = document.querySelector('[data-rk-raster]');
    var balken = wurzel.querySelector('[data-rk-balken]');
    var stand = wurzel.querySelector('[data-rk-stand]');
    var text = wurzel.querySelector('[data-rk-knopf-text]');
    var gesamt = parseInt(wurzel.dataset.gesamt, 10) || 0;
    var urspruenglich = text ? text.textContent : 'Mehr laden';

    knopf.addEventListener('click', function () {
      var url = knopf.dataset.url;
      if (!url || knopf.disabled) return;

      knopf.disabled = true;
      knopf.setAttribute('aria-busy', 'true');
      if (text) text.textContent = 'Lädt …';

      fetch(url)
        .then(function (a) {
          if (!a.ok) throw new Error(a.status);
          return a.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var neu = doc.querySelector('[data-rk-raster]');
          if (!neu || !raster) throw new Error('kein Raster');

          var karten = neu.children;
          var erste = null;
          while (karten.length) {
            var karte = karten[0];
            raster.appendChild(karte);
            if (!erste) erste = karte;
          }

          // Für Screenreader: Fokus auf das erste neue Produkt.
          if (erste) {
            var ziel = erste.querySelector('a');
            if (ziel) {
              ziel.setAttribute('tabindex', '-1');
              ziel.focus({ preventScroll: true });
            }
          }

          /* Dieselbe Meldung wie bei den Empfehlungen: die eben angehängten
             Kacheln sollen auftreten statt einfach dazustehen. */
          document.dispatchEvent(new CustomEvent('rk:inhalt-neu'));

          /* Nur Produktkacheln zählen – die Gutschein-Kachel ist kein Produkt. */
          var da = raster.querySelectorAll('.rk-pkarte').length;
          if (stand) stand.textContent = da;
          if (balken && gesamt) balken.style.width = (da / gesamt * 100) + '%';

          var weiter = doc.querySelector('[data-rk-knopf]');
          if (weiter && weiter.dataset.url) {
            knopf.dataset.url = weiter.dataset.url;
            knopf.disabled = false;
            knopf.removeAttribute('aria-busy');
            if (text) text.textContent = urspruenglich;
          } else {
            knopf.remove();
          }
        })
        .catch(function () {
          // Fehlgeschlagen: zurück in den bedienbaren Zustand, damit
          // der Kunde nicht vor einem toten Knopf steht.
          knopf.disabled = false;
          knopf.removeAttribute('aria-busy');
          if (text) text.textContent = 'Nochmal versuchen';
        });
    });
  }

  function alle() {
    document.querySelectorAll('[data-rk-mehr]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  // Im Theme-Editor neu verdrahten, wenn die Section neu gezeichnet wird.
  document.addEventListener('shopify:section:load', alle);
})();
